import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { Box, IconButton, Menu, MenuItem, Stack, Tooltip, Typography, } from "@mui/material";
import { DeleteOutlineRounded, EmailOutlined, LinkRounded, MoreVert, } from "@mui/icons-material";
import { useStoreFileViewerContext } from "../../hooks/context";
import { parseErrorFromPangea } from "../../utils";
var ShareOptions = function (_a) {
    var object = _a.object, onDelete = _a.onDelete;
    var _b = useState(false), updating = _b[0], setUpdating = _b[1];
    var _c = useState(false), sending = _c[0], setSending = _c[1];
    var _d = useState(false), sent = _d[0], setSent = _d[1];
    var _e = useState(false), copied = _e[0], setCopied = _e[1];
    var _f = useState(false), copying = _f[0], setCopying = _f[1];
    var _g = useState(""), error = _g[0], setError = _g[1];
    var _h = useStoreFileViewerContext(), apiRef = _h.apiRef, configurations = _h.configurations;
    var _j = useState(null), optionsEl = _j[0], setOptionsEl = _j[1];
    var handleRemove = function () {
        var _a;
        if (!(object === null || object === void 0 ? void 0 : object.id) || !((_a = apiRef === null || apiRef === void 0 ? void 0 : apiRef.share) === null || _a === void 0 ? void 0 : _a.delete))
            return;
        setUpdating(true);
        apiRef.share
            .delete({
            ids: [object.id],
        })
            .finally(function () {
            if (onDelete)
                onDelete();
            setUpdating(false);
            handleClose;
        });
    };
    var resendEmail = function () {
        var _a, _b, _c;
        if (!(object === null || object === void 0 ? void 0 : object.id) ||
            !((_a = apiRef === null || apiRef === void 0 ? void 0 : apiRef.share) === null || _a === void 0 ? void 0 : _a.send) ||
            !(object === null || object === void 0 ? void 0 : object.recipient_email) ||
            sending)
            return;
        setSending(true);
        var links = [
            { id: object.id, email: object.recipient_email },
        ];
        apiRef.share
            .send({
            sender_email: object.sender_email ||
                ((_b = configurations === null || configurations === void 0 ? void 0 : configurations.sender) === null || _b === void 0 ? void 0 : _b.email) ||
                "no-reply@pangea.cloud",
            sender_name: object.sender_name || ((_c = configurations === null || configurations === void 0 ? void 0 : configurations.sender) === null || _c === void 0 ? void 0 : _c.name),
            links: links,
        })
            .finally(function () {
            setSent(true);
            setSending(false);
        });
    };
    var copyLink = function () {
        var _a, _b;
        if (!((_a = apiRef.share) === null || _a === void 0 ? void 0 : _a.get)) {
            return;
        }
        setCopying(true);
        return (_b = apiRef.share) === null || _b === void 0 ? void 0 : _b.get({
            id: object.id,
        }).then(function (response) {
            var _a, _b;
            var link = (_b = (_a = response === null || response === void 0 ? void 0 : response.result) === null || _a === void 0 ? void 0 : _a.share_link_object) === null || _b === void 0 ? void 0 : _b.link;
            if (link && typeof link === "string") {
                navigator.clipboard.writeText(link);
                setCopied(true);
            }
            else {
                throw Error("Unable to retrieve share link");
            }
        }).catch(function (error) {
            setError(parseErrorFromPangea(error));
        }).finally(function () {
            setCopying(false);
        });
    };
    var handleClose = function () {
        setOptionsEl(null);
    };
    useEffect(function () {
        if (copied) {
            setTimeout(function () {
                setCopied(false);
                setOptionsEl(null);
            }, 1000);
        }
    }, [copied]);
    useEffect(function () {
        if (sent) {
            setTimeout(function () {
                setSent(false);
                setOptionsEl(null);
            }, 1000);
        }
    }, [sent]);
    return (_jsxs(Box, { sx: { marginLeft: "auto" }, children: [_jsx(IconButton, { onClick: function (event) {
                    setOptionsEl(event.currentTarget);
                    event.stopPropagation();
                }, "data-testid": "Share-".concat(object === null || object === void 0 ? void 0 : object.id, "-Options-Btn"), children: _jsx(MoreVert, {}) }), _jsxs(Menu, { open: !!optionsEl, anchorEl: optionsEl, onClose: function () { return setOptionsEl(null); }, sx: {
                    ".MuiList-root": {
                        width: "200px",
                    },
                    button: {
                        justifyContent: "start",
                        paddingLeft: 2,
                    },
                    ".MuiButton-textPrimary": {
                        color: function (theme) { return theme.palette.text.primary; },
                    },
                }, children: [!!object.id && !!object.recipient_email && (_jsx(MenuItem, { onClick: resendEmail, disabled: sending || sent, children: _jsxs(Stack, { direction: "row", gap: 1, children: [_jsx(EmailOutlined, { fontSize: "small" }), _jsx(Typography, { variant: "body2", children: sending
                                        ? "Sending email"
                                        : sent
                                            ? "Email sent"
                                            : "Resend email" })] }) })), !!object.id && !object.recipient_email && (_jsx(MenuItem, { onClick: copyLink, disabled: copied || copying, children: _jsx(Tooltip, { title: !!error ? "".concat(error, ". Click to retry") : "", children: _jsxs(Stack, { direction: "row", gap: 1, children: [_jsx(LinkRounded, { fontSize: "small", color: !!error ? "error" : !!copied ? "success" : undefined }), _jsx(Typography, { variant: "body2", color: !!error
                                            ? "error.main"
                                            : !!copied
                                                ? "success.main"
                                                : undefined, children: copied ? "Link copied" : error || "Copy link" })] }) }) })), _jsx(MenuItem, { onClick: handleRemove, disabled: updating, children: _jsxs(Stack, { direction: "row", gap: 1, children: [_jsx(DeleteOutlineRounded, { fontSize: "small" }), _jsx(Typography, { variant: "body2", children: updating ? "Deleting" : "Remove" })] }) })] })] }));
};
export default ShareOptions;
